import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getCronograma, upsertCronograma, CronogramaInput } from '../services/api';

export const useObraCronograma = (obraId: string | undefined) => {
    const queryClient = useQueryClient();
    const id = Number(obraId);

    const {
        data: cronograma,
        isLoading: loadingCronograma,
        error: errorCronograma,
        refetch: refetchCronograma
    } = useQuery({
        queryKey: ['cronograma', id],
        queryFn: () => getCronograma(id),
        enabled: !!id,
    });

    const updateCronogramaMutation = useMutation({
        mutationFn: (input: CronogramaInput) => upsertCronograma(input),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['cronograma', id] });
        },
    });

    return {
        cronograma,
        loadingCronograma,
        errorCronograma,
        refetchCronograma,
        updateCronograma: updateCronogramaMutation.mutateAsync,
        isUpdating: updateCronogramaMutation.isPending
    };
};
